module.exports = __webpack_public_path__ + "img/bg-empresa.628eb534.png";